export const formSectionTheme = {
  bg: 'palette.surface.2',
  borderRadius: '12px',
  text: 'palette.tertiary.90',
};
